import { render } from "./passFang.vue?vue&type=template&id=5acfda21&scoped=true"
import script from "./passFang.vue?vue&type=script&lang=js"
export * from "./passFang.vue?vue&type=script&lang=js"

import "./passFang.vue?vue&type=style&index=0&id=5acfda21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5acfda21"

export default script